'use strict';

import { blogGrid } from './modules/blog-grid';

document.addEventListener('DOMContentLoaded', () => {
	blogGrid.init();
});
